// helpers/api rethrows the axios error untouched when the body has no `errors`
// key, so a 422 reason arrives as response.data.message and a 403 has no body.
const FORBIDDEN = 'This page belongs to another company, so only its owner can replace the file.';

export const reasonFrom = (error: unknown): string | null => {
  if (typeof error !== 'object' || error === null) return null;

  const response = (error as { response?: { status?: number; data?: { message?: unknown } } }).response;
  if (response?.status === 403) return FORBIDDEN;

  const message = response?.data?.message;

  return typeof message === 'string' ? message : null;
};
